export default __webpack_public_path__ + "static/media/3.681cf77d.jpg";